import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const featureSliders = document.querySelectorAll('.swiper-feature-block');

featureSliders.forEach((featureSlider) => {
    const paginationEl = featureSlider.querySelector(
        '.swiper-pagination-custom'
    );
    const slidesCount = parseInt(featureSlider.dataset.slidesCount) || 0;
    const enableLoop = slidesCount > 1;

    let progress = 0;
    let duration = 8000;
    let isPlaying = true;
    let startTime;
    let rafId;
    let swiper;

    const autoHeightEnabled = featureSlider.dataset.autoHeight === 'true';

    swiper = new Swiper(featureSlider, {
        modules: [Pagination],
        loop: enableLoop,
        speed: 1000,
        autoplay: false,
        breakpoints: {
            768: {
                autoHeight: false
            },
            0: {
                autoHeight: autoHeightEnabled
            }
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}" data-index="${index}">
                            <span class="number">${index + 1}</span>
                        </span>`;
            },
        },
        on: {
            init(swiperInstance) {
                swiper = swiperInstance;
                startCustomAutoplay();
                resetLoaders();
                updateBulletClasses();
                
                if (autoHeightEnabled) {
                    setTimeout(() => {
                        swiper.updateAutoHeight();
                    }, 200);
                }
            },
            slideChangeTransitionStart() {
                progress = 0;
                startTime = performance.now();
                resetLoaders();
                updateBulletClasses();
                
                handleVideoOnSlideChange();
            },
        },
    });

    function startCustomAutoplay() {
        startTime = performance.now();
        loop();
    }

    function loop(now) {
        if (!isPlaying) return;
        if (!startTime) startTime = now;
        const elapsed = now - startTime;
        progress = Math.min((elapsed / duration) * 100, 100);
        if (swiper) updateLoader(swiper.realIndex, Math.round(progress));
        if (progress >= 100) {
            if (enableLoop || swiper.activeIndex < slidesCount - 1) {
                swiper.slideNext();
                progress = 0;
                startTime = performance.now();
            } else {
                isPlaying = false;
            }
        }
        if (isPlaying) {
            rafId = requestAnimationFrame(loop);
        }
    }

    function resetLoaders() {
        paginationEl
            .querySelectorAll('.swiper-pagination-bullet')
            .forEach((bullet, i) => {
                const isActive = bullet.classList.contains(
                    'swiper-pagination-bullet-active'
                );
                if (isActive) {
                    bullet.innerHTML = `
                        <div class="relative">
                            <div class="percentage" style="--p: ${progress}%">
                            </div>
                            <div class="number w-full h-full z-10 absolute top-0 left-0 flex justify-center items-center">
                                <span>${i + 1}</span>
                            </div>
                            <div class="play-icon w-full h-full z-20 absolute top-0 left-0 flex justify-center items-center">
                                <i class="fa-solid fa-pause text-white text-lg"></i>
                            </div>
                        </div>
                    `;

                    setTimeout(() => {
                        const percentage = bullet.querySelector('.percentage');
                        if (percentage) {
                            percentage.classList.add('show');
                        }
                        
                        const playIcon = bullet.querySelector('.play-icon');
                        if (playIcon) {
                            playIcon.addEventListener('click', (e) => {
                                e.stopPropagation();
                                // console.log('Play clicked for slide:', i + 1, 'in block:', featureSlider);
                                
                                const currentSlide = swiper.slides[swiper.activeIndex];
                                const video = currentSlide ? currentSlide.querySelector('video') : null;
                                
                                if (video) {
                                    const icon = playIcon.querySelector('i');
                                    
                                    if (video.paused) {
                                        video.play();
                                        icon.className = 'fa-solid fa-pause text-white text-lg';
                                        // console.log('Video playing');
                                    } else {
                                        video.pause();
                                        icon.className = 'fa-solid fa-play text-white text-lg';
                                        // console.log('Video paused');
                                    }
                                }
                            });
                        }
                    }, 100);
                } else {
                    bullet.innerHTML = `
                        <div class=" w-[3.4rem] h-[3.4rem] flex justify-center items-center">
                            <span class="number">${i + 1}</span>
                        </div>
                    `;
                }
            });
    }

    function updateBulletClasses() {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const slideType = currentSlide ? currentSlide.getAttribute('data-slide-type') : null;
        const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
        
        // console.log('=== UPDATE BULLET CLASSES ===');
        // console.log('SLIDER BLOCK:', featureSlider);
        // console.log('SLIDE TYPE:', slideType, 'ACTIVE INDEX:', swiper.activeIndex);
        // console.log('Current slide element:', currentSlide);
        
        if (activeBullet && slideType) {
            const numberDiv = activeBullet.querySelector('.number');
            const playIconDiv = activeBullet.querySelector('.play-icon');
            
            // console.log('slideType exact value:', JSON.stringify(slideType));
            // console.log('slideType === "Video":', slideType === 'Video');
            // console.log('slideType === "Imagen":', slideType === 'Imagen');
            
            if (slideType === 'video') {
                // console.log('ES VIDEO - OCULTANDO NUMERO, MOSTRANDO PLAY');
                numberDiv.style.setProperty('display', 'none', 'important');
                playIconDiv.style.setProperty('display', 'flex', 'important');
            } else if (slideType === 'image') {
                // console.log('ES IMAGEN - MOSTRANDO NUMERO, OCULTANDO PLAY');
                numberDiv.style.setProperty('display', 'flex', 'important');
                playIconDiv.style.setProperty('display', 'none', 'important');
            } else {
                // console.log('TIPO DESCONOCIDO:', slideType);
            }
        }
    }

    function updateLoader(index, percent) {
        const bullet = paginationEl.querySelectorAll(
            '.swiper-pagination-bullet'
        )[index];
        if (bullet) {
            const percentage = bullet.querySelector('.percentage');
            if (percentage) {
                percentage.style.setProperty('--p', `${percent}%`);
            }
        }
    }

    function handleVideoOnSlideChange() {
        const allVideos = featureSlider.querySelectorAll('video');
        allVideos.forEach(video => {
            if (!video.paused) {
                video.pause();
            }
        });

        const currentSlide = swiper.slides[swiper.activeIndex];
        const slideType = currentSlide ? currentSlide.getAttribute('data-slide-type') : null;
        
        if (slideType === 'video') {
            const currentVideo = currentSlide.querySelector('video');
            if (currentVideo) {
                currentVideo.play();
                
                const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
                if (activeBullet) {
                    const playIcon = activeBullet.querySelector('.play-icon i');
                    if (playIcon) {
                        playIcon.className = 'fa-solid fa-pause text-white text-lg';
                    }
                }
            }
        }
    }
});
